import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom'; 
import Page from "../../../components/Page";
import { Routes } from "../../../routes/RouteConstants";
import Article from "../../../components/Article";
import Loading from "../../../components/Loading";
import useUpdateStatus from '../../../api/useUpdateStatus';

const EmailActionPage = () => {
  const navigate = useNavigate();
  const { type, bookingId } = useParams();
  const targetRouteBeforeLogin = Routes.EMAIL_ACTION.replace(':type', type).replace(':bookingId', bookingId);
  const { updateStatus } = useUpdateStatus(targetRouteBeforeLogin);

  let title;
  let newStatus;
  if (type === 'booking-approval') {
    title = 'Foglalás jóváhagyása';
    newStatus = 'BOOKED';
  } else if (type === 'booking-rejection') {
    title = 'Foglalás elutasítása';
    newStatus = 'REJECTED';
  }

  // The mail can be older than the booking: a guest who cancelled meanwhile (DEC-0023), or a
  // decision already taken or a time already passed (DEC-0026), leaves nothing to decide on. The
  // snackbar says so, and the dashboard shows what there is instead.
  useEffect(() => {
    updateStatus(bookingId, newStatus, () => {
      navigate(Routes.EMAIL_ACTION_SUCCESS.replace(':type', type));
    }, () => navigate(Routes.DASHBOARD, { replace: true }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Page>
      <Article title={title}>
        <Loading />
      </Article>
    </Page>
  );
};

export default EmailActionPage;
